import React from "react";
import { Icon } from "@amzn/meridian";
import cameraTokens from "@amzn/meridian-tokens/base/icon/camera";
import "./CaptureButton.scss";

interface CaptureButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

/**
 * Reusable capture button component
 * Displays camera icon for capturing photos
 */
const CaptureButton: React.FC<CaptureButtonProps> = ({ onClick, disabled = false }) => {
  return (
    <div className="capture-button-container">
      <div
        className="picture-capturing-icon-wrapper"
        onClick={disabled ? undefined : onClick}
        style={{ opacity: disabled ? 0.5 : 1, cursor: disabled ? 'not-allowed' : 'pointer' }}
      >
        <Icon tokens={cameraTokens} />
      </div>
    </div>
  );
};

export default CaptureButton;
